



























































































import { Component, Inject, Mixins, Prop, Watch } from "vue-property-decorator";
import { NavigationGuardNext, Route } from "vue-router";
import MaltaModule, { MODULE_ID, PORTAL_TARGET } from "../../index";
import ProjectProposalMixin from "../../mixins/ProjectProposal";
import Utils from "../../mixins/Utils";
import { StandardOutput, StandardOutputs } from "../../models/ProjectProposal";
import { Product, Locality } from "../../models/Decoding";
import FormConfirmBeforeDelete from "../private/forms/FormConfirmBeforeDelete.vue";
import FormHasError from "../private/forms/FormHasError.vue";
import ProductsListModal from "../private/ProductsListModal.vue";

@Component({
    components: {
        ProductsListModal,
        FormHasError,
        FormConfirmBeforeDelete
    },

    beforeRouteLeave(this: ProjectProposalStandardOutputsEdit, to: Route, from: Route, next: NavigationGuardNext<Vue>) {
        if (this.standardOutput) this.isValid = this.standardOutput.isValid;
        if (this.isValid.length === 0) next();
        else {
            if (this.canEdit && !this.force) this.showErrorContinueModal = true;
            else next();
        }
    }
})
export default class ProjectProposalStandardOutputsEdit extends Mixins(ProjectProposalMixin, Utils) {
    @Inject(MODULE_ID) maltaModule!: MaltaModule;
    @Prop() itemId!: string;
    @Prop({ required: true }) standardOutputs!: StandardOutputs;

    searchProduct = "";
    filteredValues: Product[] = [];
    selectedProduct: Product | null = null;
    showProductsListModal = false;
    searchLocality = "";
    filteredLocalityValues: Locality[] = [];
    selectedLocality: Locality | null = null;
    showLocalitiesListModal = false;
    isValid: string[] = [];
    showErrorContinueModal = false;
    force = false;
    showDelete = false;

    goBack(force = false) {
        this.force = force;
        this.$router.push({ name: "project-proposal-standard-output-list" });
    }

    get portalTarget(): string {
        return PORTAL_TARGET;
    }

    get standardOutput(): StandardOutput | null {
        if (this.standardOutputs) {
            return (
                this.standardOutputs.standardOutputs.find(
                    e => e.standard_output_id.toString() === this.itemId.toString()
                ) ?? null
            );
        }
        return null;
    }

    created(): void {
        if (this.standardOutput) {
            if (this.standardOutput.agricultural_product) this.selectedProduct = this.standardOutput.product;
            this.standardOutput.touched = true;
        }
    }

    async saveAndGoBack() {
        if (this.standardOutput) {
            this.isValid = this.standardOutput.isValid;
            this.isValid.length === 0
                ? this.$emit("save")
                : this.toast(this.i18n("form-not-valid").toString(), { type: "error" });
        }
    }

    mounted(): void {
        if (this.standardOutput === null) {
            this.toast(this.i18n("item-not-found").toString(), { type: "error" });
            this.$router.push({ name: "project-proposal-standard-output-list" });
        }
    }

    @Watch("standardOutput.num_economic_size")
    calculateSoValue() {
        if (this.standardOutput) {
            if (this.standardOutput.num_economic_size && this.standardOutput.coefficient)
                this.standardOutput.so_value = this.standardOutput.coefficient * this.standardOutput.num_economic_size;
            else this.standardOutput.so_value = null;
        }
    }

    productsToString(product: Product | null): string {
        return product?.agricultural_product ? product.agricultural_product : "";
    }

    @Watch("searchProduct")
    async filterValues() {
        let ret: Product[] = [];
        const data = await this.maltaModule.decodingApi.getProduct(
            this.subjectId,
            this.applicationId,
            this.searchProduct
        );
        if (data) {
            if (this.searchProduct != "") {
                ret = [...ret, ...data.records];
                this.filteredValues = ret;
                return;
            }

            ret = data.records;
        }
        this.filteredValues = ret;
    }

    @Watch("selectedProduct")
    onSelected(): void {
        if (this.standardOutput) {
            this.standardOutput.product = this.selectedProduct;
            this.searchProduct = this.selectedProduct?.agricultural_product
                ? this.selectedProduct.agricultural_product
                : "";
            this.calculateSoValue();
        }
    }

    onReset(): void {
        if (this.standardOutput) {
            this.searchProduct = "";
            this.selectedProduct = null;
            this.standardOutput.product = this.selectedProduct;
            this.calculateSoValue();
        }
    }

    openProductsListModal(): void {
        this.showProductsListModal = true;
    }
}
